import { Component, ViewEncapsulation } from '@angular/core';
import { fadeInOnEnterAnimation, fadeOutOnLeaveAnimation } from '../../../animations/index';

@Component({
  selector: 'app-content-cabinet',
  templateUrl: './content.component.html',
  styleUrl: './content.component.scss',
  encapsulation: ViewEncapsulation.ShadowDom,
  animations: [fadeInOnEnterAnimation(), fadeOutOnLeaveAnimation()]
})
export class ContentCabinetComponent {}
